import * as types from '../../constants/actionTypes';
import initialState from '../initialState';

export default function (state = initialState.productFeatures, action) {
   switch (action.type) {
      case types.LOAD_PRODUCT_FEATURES_SUCCESS : {
         return action.payload.productFeatures;
      }
      case types.ADD_PRODUCT_FEATURE : {
         const index = state.findIndex((pFeatures) => (
            pFeatures.id === action.payload.productFeature.id
         ));
         if (index === -1) {
            return state.concat(action.payload.productFeature);
         } else {
            return state;
         }
      }

      case types.REMOVE_PRODUCT_FEATURE : {
         const index = state.findIndex((pFeatures) => (
            pFeatures.id === action.payload.id
         ));
         if (index > -1) {
            return state
               .slice(0, index)
               .concat(state.slice(index + 1));
         } else {
            return state;
         }
      }

      default:
         return state;
   }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/productMainEdit/productFeatureReducers.js
 **/